import React, { useEffect } from "react";
import "../styles/Home.css";

// Importação dos componentes
import Header from "../components/Header";
import Features from "../components/Features";
import Testimonials from "../components/Testimonials";
import About from "../components/About";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";
import MerciaChat from "../components/MerciaChat"; // 🔹 Importando o chatbot
import { MdMailOutline } from "react-icons/md";
import { Helmet } from "react-helmet";

const Home = () => {
  useEffect(() => {
    const toggleSide = { value: true };

    const generateQRToBackground = () => {
      const qrContainer = document.getElementById("qr-container");
      if (!qrContainer) return console.warn("QR Container not found");

      const qr = document.createElement("div");
      qr.className = "qr-animation";

      const marginFromEdge = 150;
      const isLeft = toggleSide.value;
      toggleSide.value = !toggleSide.value;

      const startX = isLeft ? `${marginFromEdge}px` : `${window.innerWidth - marginFromEdge}px`;
      const startY = `${Math.random() * window.innerHeight}px`;

      qr.style.position = "absolute";
      qr.style.left = startX;
      qr.style.top = startY;

      const img = document.createElement("img");
      img.src = "/assets/qr-code.png";
      img.alt = "QR Code";
      img.style.width = "60px";
      img.style.height = "60px";
      img.style.opacity = "1";
      img.style.transition = "opacity 1s";

      qr.appendChild(img);
      qrContainer.appendChild(qr);

      const containerRect = qrContainer.getBoundingClientRect();
      const targetX = containerRect.left + containerRect.width / 2 - 30 + 20;
      const targetY = containerRect.top + containerRect.height / 2 - 30;

      qr.animate(
        [
          { transform: `translate(0, 0)` },
          { transform: `translate(${targetX - parseFloat(startX)}px, ${targetY - parseFloat(startY)}px)` },
        ],
        { duration: 4000, easing: "ease-in-out", fill: "forwards" }
      );

      setTimeout(() => {
        img.style.opacity = "0";
      }, 3500);

      setTimeout(() => qr.remove(), 3500);
    };

    const interval = setInterval(() => {
      generateQRToBackground();
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Helmet>
        <title>RondaGO - Gestão Inteligente para Condomínios</title>
        <meta name="description" content="Simplifique a gestão do seu condomínio com o RondaGO. Controle rondas, inspeções, manutenção de ativos e tarefas operacionais de forma eficiente." />
        <meta name="keywords" content="gestão de condomínio, rondas, inspeções, manutenção, QR Code, síndico, administração predial" />
        <meta name="author" content="RondaGO" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* Cabeçalho */}
      <Header />

      {/* Hero Section */}
      <section className="hero">
        <p className="hero-subtitle"> 
           <strong>Gestão por QR Code na palma da sua mão</strong>
       </p>
        <div id="qr-container" style={{ position: "relative", height: "400px" }}></div>
        <img src="/assets/mao-celular.png" alt="Homem segurando celular" className="hero-image" />
      </section>

      {/* Seção Sobre o RondaGO */} 
      <section id="about">
        <About />
      </section>

      {/* Seção Funcionalidades */}
      <Features />

      {/* Seção Testimonials */}
      <Testimonials />

      {/* Seção de Contato */}
      <section className="contact-section">
        <h2 style={{ textAlign: "center", fontSize: "22px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
          <MdMailOutline size={28} color="#007bff" /> Entre em contato para saber mais!
        </h2>
        <p style={{ textAlign: "center", fontSize: "16px" }}>
          Preencha os campos abaixo e nossa equipe entrará em contato com você.
        </p>
        <ContactForm />
      </section>

      {/* Seção Footer */}
      <Footer />

      {/* 🔹 Chatbot MercIA como botão flutuante */}
      <MerciaChat />

    </>
  );
};

export default Home;
